import React, {useEffect, useState} from "react";
import Api from "../../../services/api.js";
import {useOutletContext} from "react-router-dom";
import PaginationComponent from "../../../components/pagination";
import DateComponent from '../../../components/datepicker';
import moment from "moment/moment";
import {toast} from "react-toastify";
import LoadingComponent from "../../../components/loading";
import { END_DATE, START_DATE } from "../../../utility/index.js";

function RevenueApp() {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(4);
    const [selectedFilter, setSelectedFilter] = useState("");

    const [startDate,setStartDate] = useState(moment().subtract(START_DATE, 'days'));
    const [endDate,setEndDate] = useState(moment().subtract(END_DATE, 'days'));

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const handleChangePage = (page) => {
        setCurrentPage(page);
    }
    const handleChangeDate = (event, picker) => {
        setStartDate(picker.startDate)
        setEndDate(picker.endDate)
    };

    const formatNumber = (num) => num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    // const data_json = {"code":0,"proceeds_total":60,"data":[{"id":1,"app":"Google Ads","est_monetization": 21.4,"est_total_cost":31.1,"total_profit":12.1,"developer_profit":1},{"id":2,"app":"Google Ads","est_monetization": 21.4,"est_total_cost":31.1,"total_profit":12.1,"developer_profit":1}]};

    const fetchData = (filter, start, end) => {
        setLoading(true);
        Api.get(`/api/data_connector?filter=${filter}&start_date=${start}&end_date=${end}&page=${currentPage}`)
            .then(result => {
                if (result.data.code == 0) {
                    setData(result.data.data);
                } else {
                    toast.error("Lỗi lấy dữ liệu !!");
                }
                setLoading(false)
            });
    };

    useEffect(() => {
        fetchData(selectedFilter, startDate, endDate);
    }, [currentPage]);


    const handleApply = () => {
        const filterValue = document.querySelector("select").value;
        fetchData(filterValue, startDate, endDate);
    };

    const totalEstMonetization = 0;
    const totalEstTotalCost = 0;
    const totalProfit = 0;
    const totalDeveloperProfit = 0;

    // const totalEstMonetization = data.reduce((sum, item) => sum + item.est_monetization, 0);
    // const totalEstTotalCost = data.reduce((sum, item) => sum + item.est_total_cost, 0);
    // const totalProfit = data.reduce((sum, item) => sum + item.total_profit, 0);
    // const totalDeveloperProfit = data.reduce((sum, item) => sum + item.developer_profit, 0);

    return (
        <>
            <section className="main__filter">
                <div className="filter">
                    <div className="container-fluid">
                        <div className="row d-flex flex-row-reverse">
                            <div className="col-md-1">
                                <button className="btn btn-primary float-right" onClick={handleApply}>Apply</button>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group" style={{marginBottom: "0"}}>
                                    <div className="filter-sticky">
                                        <div className="d-flex justify-content-end">
                                            <DateComponent startDate={startDate}
                                                           endDate={endDate}
                                                           handleChangeDate={handleChangeDate}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group" style={{marginBottom: "0"}}>
                                    <select className="form-select form-select-lg" aria-label="Default select example" value={selectedFilter} onChange={(e) => setSelectedFilter(e.target.value)}>
                                        <option value="">Filter app</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section className="main__content">
                <div className="container-fluid">
                    <div className="detail-body">
                        <div className="overview_content pd-20">
                            <div className="mb-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="title-head-box">
                                            <p className="title-block">Revenue reconciliation</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="box box--chart mb-4">
                                            <div className="box__content custom-table">
                                                <div className="searchForm col-md-3 mt-2">
                                                    <button type="button" className="btn btn-light"><i
                                                        className="fas fa-download"></i> CSV</button>
                                                </div>
                                                <LoadingComponent loading={loading} />
                                                <div className="table-responsive">
                                                    <table className="table m-0 table--text-bold">
                                                        <thead>
                                                        <tr className="border-bt">
                                                            <th>App</th>
                                                            <th className="text-center">EST, Monetization</th>
                                                            <th className="text-center">EST, TOTAL, COST</th>
                                                            <th className="text-center">TOTAL, PROFIT</th>
                                                            <th className="text-center">DEVELOPER PROFIT</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {data.length > 0 ? (
                                                            data.map((item) => (
                                                                <tr key={item.id} className="hover:bg-gray-100">
                                                                    <td>
                                                                        {/*{item.app}*/}
                                                                    </td>
                                                                    <td className="text-center"></td>
                                                                    <td className="text-center"></td>
                                                                    <td className="text-center"></td>
                                                                    <td className="text-center"></td>

                                                                    {/*<td className="text-center">{formatNumber(item.est_monetization)}</td>*/}
                                                                    {/*<td className="text-center">{formatNumber(item.est_total_cost)}</td>*/}
                                                                    {/*<td className="text-center">{formatNumber(item.total_profit)}</td>*/}
                                                                    {/*<td className="text-center">{formatNumber(item.developer_profit)}</td>*/}
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="6" className="border border-gray-300 px-4 py-2 text-center">
                                                                    No data available
                                                                </td>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <td className="border-gray-300 px-4 py-2 bg-gray-300 text-center">

                                                            </td>
                                                            <td className="border-gray-300 px-4 py-2 bg-gray-300 text-center">
                                                                <b>${formatNumber(totalEstMonetization)}</b>
                                                            </td>
                                                            <td className="border-gray-300 px-4 py-2 bg-gray-300 text-center">
                                                                <b>${formatNumber(totalEstTotalCost)}</b>
                                                            </td>
                                                            <td className="border-gray-300 px-4 py-2 bg-gray-300 text-center">
                                                                <b>${formatNumber(totalProfit)}</b>
                                                            </td>
                                                            <td className="border-gray-300 px-4 py-2 bg-gray-300 text-center">
                                                                <b>${formatNumber(totalDeveloperProfit)}</b>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="total_rev_app col-md-6 mt-5">
                                                    <ul>
                                                        <li>Total Estimated Adjustment MO: <span className="text-danger">$0.22</span></li>
                                                        <li>Total Estimated Adjustment Cost: <span className="text-primary">$0.22</span></li>
                                                        <li>Total Estimated IAP: <span className="text-success">$0.22</span></li>
                                                    </ul>
                                                </div>
                                                <div className="rev_alert">
                                                    <div className="alert alert-warning" role="alert">
                                                        Note: This total number does not represent the amount that you receive at each of your payment periods. Please check <a href="#" className="alert-link">payment invoices</a> to get the exact amount you receive every payment term.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <PaginationComponent
                                            current={currentPage}
                                            total={totalPage}
                                            handleChangePage={handleChangePage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default RevenueApp;
